import { EntityState, getEntityType, getIDType, QueryEntity } from '@datorama/akita';
import { tap } from 'rxjs/operators';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { Observable } from 'rxjs';
import { HttpConfig, Msg } from '@datorama/akita-ng-entity-service/lib/types';
import { HttpMethod } from '@datorama/akita-ng-entity-service/lib/ng-entity-service-notifier';
import Apiable from '@core/state/jsonentity/interfaces/apiable';

/**
 * NgEntityService modified to work with JSON-style API.
 */
export class JsonApiEntityService<S extends EntityState = any> extends NgEntityService<S> implements Apiable {

  get<T>(idOrConfig?, config?): Observable<T> {
    const vm = this;
    return super.get(idOrConfig, config)
      .pipe(
        tap(data => {
          if (idOrConfig && typeof (idOrConfig) != 'object') {
            // For getting one object (idOrConfig is an id/nonobject/number)
            vm.store.update(idOrConfig, data['data']);
            return data;
          } else {
            // For getting many objects
            vm.store.set(data['data']);
            return data;
          }
        })
      ) as Observable<T>;
  }

  getPage(page = 1, params = {}) {
    console.log(this.baseUrl);
    return this.getHttp().get(this.api, {
      params: {
        page: String(page),
        ...params
      }
    }).pipe(tap(result => {
      if (page == 1) {
        // Reset the store if we want to only show the first page
        this.store.set({});
      }
      this.store.add(result['data']);
      return result;
    }));
  }

  update<T>(id: getIDType<S>, entity: getEntityType<S>, config?: HttpConfig & {
    method: HttpMethod.PUT | HttpMethod.PATCH;
  } & Msg): Observable<T> {
    if (id) {
      return super.update<T>(id, entity, config).pipe(
        tap(data => {
          this.store.update(id, data['data']);
        })
      );
    }else {
      return super.add<T>(entity, config).pipe(
        tap(data => {
          this.store.add(id, data['data']);
        })
      );
    }
  }
}
